import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil, throttleTime } from 'rxjs/operators'

export const TRN_MATCH_BIOSEC_SAVE_FETCH = 'TRN_MATCH_BIOSEC_SAVE_FETCH'
export const TRN_MATCH_BIOSEC_SAVE_FETCH_CANCELED = 'TRN_MATCH_BIOSEC_SAVE_FETCH_CANCELED'
export const TRN_MATCH_BIOSEC_SAVE_FETCH_ERROR = 'TRN_MATCH_BIOSEC_SAVE_FETCH_ERROR'
export const TRN_MATCH_BIOSEC_SAVE_FETCH_FULFILLED = 'TRN_MATCH_BIOSEC_SAVE_FETCH_FULFILLED'

export const matchBiosecuritySaveFetch = (payload, content = null) => ({
  notification: {
    id: TRN_MATCH_BIOSEC_SAVE_FETCH,
    children: content,
    dismissAfter: 5000,
    title: 'Guardando encuesta de salud...',
  },
  payload,
  type: TRN_MATCH_BIOSEC_SAVE_FETCH,
})

export const matchBiosecuritySaveFetchFulfilled = (payload) => ({
  notification: {
    ...payload.originalAction.notification,
    title: 'Encuesta de salud guardada.',
  },
  payload,
  type: TRN_MATCH_BIOSEC_SAVE_FETCH_FULFILLED,
})

export const matchBiosecuritySaveFetchCanceled = () => ({
  payload: null,
  type: TRN_MATCH_BIOSEC_SAVE_FETCH_CANCELED,
})

export const matchBiosecuritySaveFetchError = (payload) => ({
  payload,
  type: TRN_MATCH_BIOSEC_SAVE_FETCH_ERROR,
})

export const matchBiosecuritySaveFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_MATCH_BIOSEC_SAVE_FETCH),
    throttleTime(7000),
    mergeMap((action) =>
      epicServerRequest(
        'post',
        `${APP.api_url}/sports/soccer/match/${action.payload.matchId}/biosecurity`,
        action,
        action.payload,
      ).pipe(
        map(epicResponseHandler(matchBiosecuritySaveFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_MATCH_BIOSEC_SAVE_FETCH, TRN_MATCH_BIOSEC_SAVE_FETCH_CANCELED))),
        catchError(epicErrorHandler(matchBiosecuritySaveFetchError, action)),
      ),
    ),
  )
